import type { DashboardSummary } from "../types";
import { useI18n } from "../lib/i18n";

export function SummaryCards({ summary }: { summary: DashboardSummary }) {
  const { t } = useI18n();
  const cards = [
    { label: t("active"), value: summary.totalActive, tone: "teal" },
    { label: t("overdue"), value: summary.overdue, tone: "coral" },
    { label: t("dueThisWeek"), value: summary.dueThisWeek, tone: "amber" },
    { label: t("confirmed"), value: summary.confirmed, tone: "green" },
  ];
  return (
    <section className="summary-grid" aria-label="Summary">
      {cards.map((card) => (
        <article className={`summary-card ${card.tone}`} key={card.label}>
          <span>{card.label}</span>
          <strong>{card.value}</strong>
        </article>
      ))}
    </section>
  );
}
